function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1_2883_28658",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 2v13h5v7h15V10h-6V2H2z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M2 15H0v2h2v-2zM2 2V0H0v2h2zm5 13h2v-2H7v2zm0 7H5v2h2v-2zm15 0v2h2v-2h-2zm0-12h2V8h-2v2zm-6 0h-2v2h2v-2zm0-8h2V0h-2v2zM4 15V2H0v13h4zm3-2H2v4h5v-4zm2 9v-7H5v7h4zm13-2H7v4h15v-4zm-2-10v12h4V10h-4zm-4 2h6V8h-6v4zM14 2v8h4V2h-4zM2 4h14V0H2v4z",
  mask: "url(#path-1-inside-1_2883_28658)"
})));